import type { ReactNode } from "react";
import { type MD3Theme, PaperProvider } from "react-native-paper";
import { QendoIcon } from "~/components/QendoIcon";

type PaperThemeProps = {
    theme?: MD3Theme;
    children: ReactNode;
};

export const PaperTheme = ({ theme, children }: PaperThemeProps) => {
    return (
        <PaperProvider
            theme={theme}
            settings={{
                icon: (props) => <QendoIcon {...props} />,
            }}
        >
            {children}
        </PaperProvider>
    );
};
